import React from "react";
import { Box } from "@mui/material";
import { StyledNotification } from "components/StyledUI";
import type { Approval } from "types/Order";

interface Props {
  approval?: Approval | null;
}

const OrderNotifications: React.FC<Props> = ({ approval }) => (
  <>
    {approval?.approvalMessage && (
      <Box mb={1}>
        <StyledNotification
          severity={approval.approvalStatus === "Denial" ? "error" : "warning"}>
          {approval.approvalMessage}
        </StyledNotification>
      </Box>
    )}
  </>
);

export default OrderNotifications;
